import { render } from "./RetrieveRequisitions.vue?vue&type=template&id=d02dfb5c"
import script from "./RetrieveRequisitions.vue?vue&type=script&lang=js"
export * from "./RetrieveRequisitions.vue?vue&type=script&lang=js"
script.render = render

export default script